import pdf from './Mikes_Resume.pdf' //importing here so it gets included in bundle, and can use url in iframe src

import { Modal } from 'react-bootstrap';
import { useLayoutEffect, useState, useRef } from 'react'
import useModal from '#Context/Modal'

export default function WideResume() {
    const { setModalProps } = useModal();
    const [width, setWidth] = useState(800)
    const [height, setHeight] = useState(650)
    const modalBodyElement = useRef(null)

    useLayoutEffect(() => {
        modalBodyElement.current = document.querySelector('.modal-body');
        setResumeWidth();
        window.addEventListener('resize', setResumeWidth);
        return () => {
            window.removeEventListener('resize', setResumeWidth);
        }
    }, [])

    return (
        <>
            <Modal.Body ref={modalBodyElement} className='d-flex justify-content-center'>
                {/*Note fragment #view=fith, stands for fit horizontal, passed to native pdf viewer */}
                {/* <iframe src="/Mikes_Resume.pdf#view=fith" title={'Patrick Mikes Resume'} width={width} style={{ borderRadius: '20px' }} height={height}></iframe> */}
                <iframe src={`${pdf}#view=fith`} title={'Patrick Mikes Resume'} width={width} style={{ borderRadius: '20px' }} height={height}></iframe>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <button className="btn btn-lg text-light" style={{ backgroundColor: 'var(--dark)', border: '2px solid var(--spark)' }} onClick={close}>Close</button>
            </Modal.Footer>
        </>
    )

    function close() {
        setModalProps({
            showing: false,
        })
    }

    function setResumeWidth() {
        console.log('resume resizer')
        let d = modalBodyElement.current.getBoundingClientRect();
        setWidth(Math.min(1000, d.width));
    }
}